import Grid from "@mui/material/Grid2";
import DateSelectionSection from "./DateSelectionSection";
import TaskExecutionOptions from "./TaskExecutionOptions";
import TaskTargetConfig from "./TaskTargetConfig";

/**
 * PlatformSection component.
 *
 * This component renders a section with platform options, date pickers, and quarter selection buttons for task configuration.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {Array} props.platformOptionData - Array of platform option data objects.
 * @param {RefObject[]} props.platformOptionsRefs - Refs array for platform options.
 * @param {Object} props.selectedTaskData - Object containing selected task data.
 * @param {function} props.setSelectedTaskData - Function to set the selected task data.
 * @param {Array} props.companyNames - Array of company names.
 * @param {Array} props.scraperVersionNames - Array of scraper version names.
 *
 * @returns {JSX.Element} - The JSX element for the platform section component.
 */
function PlatformSection({
  platformOptionData,
  platformOptionsRefs,
  selectedTaskData,
  setSelectedTaskData,
  companyNames,
  scraperVersionNames,
}) {
  return (
    <>
      {/* Left pane - Form inputs */}
      <Grid size={{ xs: 12, sm: 6 }} sx={{ px: { xs: 2, md: 7 }, mb: 15 }}>
        <Grid container direction="column">
          <TaskTargetConfig
            selectedTaskData={selectedTaskData}
            setSelectedTaskData={setSelectedTaskData}
            companyNames={companyNames}
            scraperVersionNames={scraperVersionNames}
          />

          <TaskExecutionOptions
            selectedTaskData={selectedTaskData}
            setSelectedTaskData={setSelectedTaskData}
            platformOptionData={platformOptionData}
            platformOptionsRefs={platformOptionsRefs}
          />
        </Grid>
      </Grid>

      {/* Right Pane - Date selection */}
      <DateSelectionSection selectedTaskData={selectedTaskData} setSelectedTaskData={setSelectedTaskData} />
    </>
  );
}

export default PlatformSection;
